import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullOldTeam on Team {
    Etag
    owners
    permissions
    public_name
    teamName
    state
    uuid
  }
`
